// Close button event listener
$(".icon-close svg").on("click", () => {
  $(".mm-login--popup").addClass("hidden");
  $("body").removeAttr("overflow");
  $("body").removeClass("overflow-hidden");
});

// Account button event listener
$(".icon--account").each((index, el) => {
  $(el).on("click", (event) => {
    event.preventDefault(); // Prevent the default link behavior
    $(".mm-login--popup").removeClass("hidden");
    $("body").attr("overflow", "hidden");
    $("body").addClass("overflow-hidden");
    setTimeout(() => {
      $("#mobileNumber").focus(); // Set focus on the input field after a delay of 200 milliseconds
    }, 200);
  });
});

// Input field event listener to allow only numeric input
$("#mobileNumber").on("input", function () {
  let numericValue = this.value.replace(/\D/g, ""); // Remove non-numeric characters from the input value
  if (this.value !== numericValue) {
    this.value = numericValue; // Update the input value with the numeric value
  }
});

var countdown;
var seconds = 30;

function startTimer() {
  countdown = setInterval(function () {
    seconds--;
    if (seconds >= 0) {
      $(".timer2").text(seconds);
    } else {
      clearInterval(countdown);

      $("#edit_number__button").show();
      $("#resend-otp--button").show();
      $(".resend-text").hide();
      $(".timer2").hide();
      $("#spinner-svg").show();
    }
  }, 1000);
}

function resetTimer() {
  clearInterval(countdown);
  seconds = 30;
  $(".timer2").text(seconds);
}

$("#resend-otp--button").hide();
$("#sign-up-resend-otp--button").hide();
$("#resend_spinner").hide();
$("#sign-up--resend_spinner").hide();
$("#sign-up").hide();
$("#otp-varification-sign-up").hide();

function sendOTP() {
  var phoneNumber = $("#mobileNumber").val();

  var payload = {
    phoneNumber: phoneNumber,
  };

  $.ajax({
    url: "https://orient.marmeto.com/api/login/otp/send",
    // url: "https://orientOTP.marmeto.com/api/login/otp/send",
    type: "POST",
    data: JSON.stringify(payload),
    contentType: "application/json",
    success: function (response) {
      console.log("POST request successful.");
      console.log("Response:", response);
      console.log(response.status);
      $(".mobile_number").hide();
      if (response.status == "NOT_FOUND") {
        $("#sign-up").show();
        $("#mobile_number").hide();
        $("#mobile_number").hide();
        console.log(" you dont have acc ");
      } else {
        $("#otp-varification").show();
        $("#input1").focus();
        $("#otp-varification-sign-up").hide();
        $('#mobile_number button[type="submit"]').removeAttr("disabled");
        $("#spinner-svg").hide();
        $("#mobile_number").hide();

        $("#edit_number__button").hide();
        startTimer();
      }
    },
    error: function (xhr, status, error) {
      console.log("POST request failed. Status code:", xhr.status);
      console.log("Error:", error);

      if (xhr.status === 400) {
        console.log("Bad request response:", xhr.responseText);
      }
    },
  });
}
$("#otp-varification").hide();

$("#mobileNumber").on("input", function () {
  $(".invalid-number").hide();
  $(".check-box--error").hide();
});

$("#mobile_number").on("submit", function (e) {
  e.preventDefault();
  if ($("#mobileNumber").val().length < 10) {
    $(".invalid-number").show();
  } else if ($("#mobile-number--checkbox").is(":checked")) {
    $('#mobile_number button[type="submit"]').attr("disabled", true);
    $("#entered_number").text($("#mobileNumber").val());
    $("#sign-up--entered_number").text($("#mobileNumber").val());
    $("#spinner-svg").show();
    $(".check-box--error").hide();
    sendOTP();
  } else {
    $(".check-box--error").show();
  }
});
$("#resend-otp--button").click(function (e) {
  e.preventDefault();
  resetTimer();
  $(".otp-input").val("");
  $("#resend-otp--button").hide();
  $("#edit_number__button").hide();
  $(".invalid-OTP ").hide();
  $("#sign-up").hide();
  var phoneNumber = $("#mobileNumber").val();

  var payload = {
    phoneNumber: phoneNumber,
  };

  $("#resend_spinner").show();

  $.ajax({
    url: "https://orient.marmeto.com/api/login/otp/send",
    // url: "https://orientOTP.marmeto.com/api/login/otp/send",
    type: "POST",
    data: JSON.stringify(payload),
    contentType: "application/json",
    success: function (response) {
      if (response.status == "NOT_FOUND") {
        $("#sign-up").hide();
        console.log(" you dont have acc ");
      } else {
        $("#otp-varification").show();
        $("#input1").focus();
        $("#otp-varification-sign-up").hide();
        $(this).removeAttr("disabled", "disabled");
        $("#spinner-svg").hide();
      }
      setTimeout(function () {
        $("#resend_spinner").hide();
        $(".resend-text").show();
        $(".timer2").show();

        startTimer();
      }, 1000);
    },
    error: function (xhr, status, error) {
      console.log("POST request failed. Status code:", xhr.status);
      console.log("Error:", error);

      if (xhr.status === 400) {
        console.log("Bad request response:", xhr.responseText);
      }
    },
  });
});

function SignUpstartTimer() {
  countdown = setInterval(function () {
    seconds--;
    if (seconds >= 0) {
      $(".timer1").text(seconds);
    } else {
      clearInterval(countdown);
      $("#sign-up-resend-otp--button").show();
      $(".resend-text").hide();
      $(".timer1").hide();
      $("#spinner-svg").show();
      $("#sign-up--edit_number__button").show();
    }
  }, 1000);
}

function SignUpresetTimer() {
  clearInterval(countdown);
  seconds = 30;
  $(".timer1").text(seconds);
}

$("#sign-up-resend-otp--button").click(function (e) {
  e.preventDefault();
  SignUpresetTimer();
  $(".otp-input").val("");
  $("#otp-varification-sign-up").show();
  $("#sign-up-resend-otp--button").hide();
  $("#sign-up--edit_number__button").hide();
  $(".invalid-OTP ").hide();
  var phoneNumber = $("#mobileNumber").val();
  var name = $("#name").val();
  var email = $("#email").val();
  var mobileNumber = $("#mobileNumber").val();

  $("#sign-up--resend_spinner").show();
  let payload = {
    email: email,
    firstName: name,
    phoneNumber: mobileNumber,
    id: "6995637567658",
  };

  $.ajax({
    url: "https://orient.marmeto.com/api/register/capture",
    // url: "https://orientOTP.marmeto.com/api/register/capture",
    type: "post",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (data) {
      console.log(data);
      $("#sign-up-resend-otp--button").hide();
      $("#sign-up--resend_spinner").hide();
      setTimeout(function () {
        $("#input1").focus();
        $("#sign-up-resend-otp--button").hide();
        $(".resend-text").show();
        $("#spinner-svg").hide();
        $(".timer1").show();
        SignUpstartTimer();
      }, 1000);
    },
  });
});

$("#edit_number__button").click(function (e) {
  event.preventDefault();
  $("#otp-varification").hide();
  $('#mobile_number button[type="submit"]').removeAttr("disabled");
  $("#spinner-svg").hide();
  $("#resend-otp--button").hide();
  $('.resend-text').show();
  $('.timer2').show();
  $("#mobile_number").show();
  $(".otp-input").val("");
  $("#mobileNumber").focus();
  
  resetTimer();
  SignUpresetTimer();
  console.log('edit_number__button')
});
$("#sign-up--edit_number__button").click(function (e) {
  event.preventDefault();
  $('#sign-up input').val("");
  $(".otp-input").val("");
  $("#otp-varification-sign-up").hide();
  $('#mobile_number button[type="submit"]').removeAttr("disabled");
  $("#spinner-svg").hide();
  $("#mobile_number").show();
  $("#mobileNumber").focus();
  SignUpresetTimer();
  resetTimer();
});

$("#otp-varification").on("submit", function (e) {
  // Get the mobile number and OTP input values
  event.preventDefault();
  var mobileNumber = $("#mobileNumber").val();
  var otpInput1 = $("#OTPinput1").val();
  var otpInput2 = $("#OTPinput2").val();
  var otpInput3 = $("#OTPinput3").val();
  var otpInput4 = $("#OTPinput4").val();
  var otp = otpInput1 + otpInput2 + otpInput3 + otpInput4;

  if (otp.length != 4) {
    $(".invalid-OTP").show();
    $("#OTP_submit_button").attr("disabled", "disabled");
    return;
  }
  $("#OTP_submit_button").attr("disabled", "disabled");
  var payload = {
    phoneNumber: mobileNumber,
    otp: otp,
  };
  // Make the POST request to verify the OTP
  $.ajax({
    url: "https://orient.marmeto.com/api/login/otp",
    // url: "https://orientOTP.marmeto.com/api/login/otp",
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (data) {
      // Handle the response data as needed

      let url = data.url;
      let respone = data;
      $(".icon-close svg").click();
      window.location.replace(url);
      $("#OTP_submit_button").removeAttr("disabled", "disabled");
    },
    error: function (xhr, status, error) {
      // Handle any errors that occurred during the request
      const responseText = xhr.responseText;
      const responseJson = JSON.parse(responseText);
      const message = responseJson.message;
      console.log(message);
      $(".invalid-OTP").show();

      if (xhr.status === 400) {
      console.log("Bad request response:", xhr.responseText);
    } else if (xhr.status === 429) {
      console.log("Too many requests response:", xhr);
      $(".invalid-OTP").hide();
      $(".too-many-requests").show();
    }
      $("#OTP_submit_button").removeAttr("disabled", "disabled");
    },
  });
});

$("#otp-varification-sign-up").on("submit", function (e) {
  e.preventDefault(); // Prevent the form from submitting normally
  $("#sign-up-otp--button").attr("disabled", "disabled");
  var mobileNumber = $("#mobileNumber").val();
  var otpInput1 = $("#input1").val();
  var otpInput2 = $("#input2").val();
  var otpInput3 = $("#input3").val();
  var otpInput4 = $("#input4").val();
  var otp = otpInput1 + otpInput2 + otpInput3 + otpInput4;
  if (otp.length != 4) {
    $(".invalid-OTP").show();
    $("#sign-up-otp--button").attr("disabled", "disabled");
    return;
  }
  // Create the request payload
  var payload = {
    phoneNumber: mobileNumber,
    otp: otp,
  };
  // Make the POST request to verify the OTP
  $.ajax({
    url: "https://orient.marmeto.com/api/register",
    // url: "https://orientOTP.marmeto.com/api/register",
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (data) {
      // Handle the response data as needed

      let url = data.url;
      let respone = data;
      $(".icon-close svg").click();
      window.location.replace(url);
      $("#sign-up-otp--button").removeAttr("disabled");
    },
    error: function (error) {
      // Handle any errors that occurred during the request
      console.error(error);
      const responseText = error.responseText;
      const responseJson = JSON.parse(responseText);
      const message = responseJson.message;
      $(".invalid-OTP").show();

      $(".error-message").text(message);
      $(".error-message").remove(".hidden");
      $("#sign-up-otp--button").removeAttr("disabled");
    },
  });
});

$("#sign-up").on("submit", function (e) {
  event.preventDefault();
  $("#sign-up--button").attr("disabled", "disabled");
  var name = $("#name").val();
  var email = $("#email").val();
  var mobileNumber = $("#mobileNumber").val();
  let payload = {
    email: email,
    firstName: name,
    phoneNumber: mobileNumber,
    id: "6995637567658",
  };
  $.ajax({
    url: "https://orient.marmeto.com/api/register/capture",
    // url: "https://orientOTP.marmeto.com/api/register/capture",
    type: "post",
    contentType: "application/json",
    data: JSON.stringify(payload),
    success: function (data) {
      console.log(data);
      $("#sign-up").hide();
      $("#sign-up--edit_number__button").hide();
      $("#otp-varification-sign-up").show();
      $("#sign-up-resend-otp--button").hide();
      setTimeout(function () {
        $("#input1").focus();
        $(".resend-text").show();
        $(".timer1").show();
        SignUpstartTimer();
      }, 1000);
      $("#sign-up--button").removeAttr("disabled", "disabled");
    },
    error: function (xhr, status, error) {
      console.log(error);
      const responseText = xhr.responseText;
      const responseJson = JSON.parse(responseText);
      const message = responseJson.message;
      if ($("message:contains('name')").length > 0) {
        $(".sign-up-error--name").text(message);
        $("#sign-up--button").attr("disabled", "disabled");
        $(".sign-up-error--email").show();
      } else {
        $(".sign-up-error--email").text(message);
        $(".sign-up-error--email").show();
        $("#sign -up--button").attr("disabled", "disabled");
      }
    },
  });
});

window.backSpace = 0;

function handleInput(inputNumber, event) {
  $("#OTP_submit_button").removeAttr("disabled", "disabled");
  const input = document.getElementById(`input${inputNumber}`);
  const inputValue = event.target.value;

  // Only allow numbers and '.' character
  const filteredValue = inputValue.replace(/[^0-9.]/g, "");
  input.value = filteredValue;

  if (filteredValue.length === 1) {
    // Focus on the next input field if available
    if (inputNumber < 4) {
      const nextInput = document.getElementById(`input${inputNumber + 1}`);
      nextInput.focus();
    }
  } else {
    // Focus on the previous input field if available
    if (inputNumber > 1) {
      if (window.backSpace == 1) {
        const previousInput = document.getElementById(
          `input${inputNumber - 1}`
        );
        previousInput.focus();
        window.backSpace = 0;
      } else {
        window.backSpace = 1;
        input.focus();
      }
    } else {
      window.backSpace = 0;
    }
  }
}

$(".otp-input").on("paste", function (e) {
  var pastedData = e.originalEvent.clipboardData.getData("text");
  var otpInputs = $(this).closest("form").find(".otp-input");
  var currentIndex = otpInputs.index(this);
  var otpArray = pastedData.trim().split("");

  // Fill the OTP input fields with the pasted values
  otpArray.forEach(function (value, index) {
    if (currentIndex + index < otpInputs.length) {
      $(otpInputs[currentIndex + index]).val(value);
    }
  });

  $(otpInputs[currentIndex + otpArray.length]).focus();
  // Trigger the keyup event for the last input to handle validation or further actions
  $(otpInputs[currentIndex + otpArray.length - 1]).trigger("keyup");
});

window.backSpace = 0;

function SignhandleInput(inputNumber, event) {
  const input = document.getElementById(`OTPinput${inputNumber}`);
  const inputValue = event.target.value;
  const filteredValue = inputValue.replace(/[^0-9.]/g, "");
  input.value = filteredValue;

  if (filteredValue.length === 1) {
    if (inputNumber < 4) {
      const nextInput = document.getElementById(`OTPinput${inputNumber + 1}`);
      nextInput.focus();
    }
  } else {
    // Focus on the previous input field if available
    if (inputNumber > 1) {
      if (window.backSpace == 1) {
        const previousInput = document.getElementById(
          `OTPinput${inputNumber - 1}`
        );
        previousInput.focus();
        window.backSpace = 0;
      } else {
        window.backSpace = 1;
        input.focus();
      }
    } else {
      window.backSpace = 0;
    }
  }
}

$("#name").on("input", function () {
  $(".sign-up-error--email").hide();
  $("#sign-up--button").removeAttr("disabled", "disabled");
});
$("#email").on("input", function () {
  $(".sign-up-error--email").hide();
  $("#sign-up--button").removeAttr("disabled", "disabled");
});

$(".otp-input").each(function () {
  $(this).on("input", function () {
    const otp = $("#input1").val() + $("#input2").val() + $("#input3").val() + $("#input4").val();
    
    if (otp.length === 4 && /^\d{4}$/.test(otp)) {
      $("#sign-up-otp--button").removeAttr("disabled");
    } else {
      $("#sign-up-otp--button").attr("disabled", true);
    }

    $(".invalid-OTP").hide();
  });
});



function validateMobileAndCheckbox() {
  const isNumberValid = $("#mobileNumber").val().length === 10;
  const isCheckboxChecked = $("#mobile-number--checkbox").is(":checked");

  if (isNumberValid && isCheckboxChecked) {
    $('#mobile_number button[type="submit"]').removeAttr("disabled");
  } else {
    $('#mobile_number button[type="submit"]').attr("disabled", true);
  }
}

$("#mobileNumber").on("input", validateMobileAndCheckbox);

$("#mobile-number--checkbox").on("change", validateMobileAndCheckbox);
